export default "__VITE_ASSET__D90ldw35__"